import React from 'react'

import { arrayOf, bool, number, shape, string } from 'prop-types'

function Card({ item, image, chipIcons, isWide = false }) {
  return (
    <li className={`datasets-explore-card${isWide ? ' datasets-explore-card--wide' : ''}`}>
      <img
        className="datasets-explore-card__image"
        src={image.src}
        width={image.width}
        height={image.height}
        alt=""
        loading="lazy"
      />
      <h3 className="datasets-explore-card__title discover-heading cgt-heading-300">{item.title}</h3>
      <p className="datasets-explore-card__text cgt-body-md">{item.text}</p>
      <ul className="datasets-explore-card__chips">
        {item.chips.map((chip, index) => (
          <li key={chip} className="datasets-explore-card__chip cgt-body-md">
            <img src={chipIcons[index].src} alt="" width={16} height={chipIcons[index].height} loading="lazy" />
            {chip}
          </li>
        ))}
      </ul>
    </li>
  )
}

Card.propTypes = {
  item: shape({
    title: string.isRequired,
    text: string.isRequired,
    chips: arrayOf(string).isRequired,
  }).isRequired,
  image: shape({ src: string.isRequired, width: number.isRequired, height: number.isRequired }).isRequired,
  chipIcons: arrayOf(shape({ src: string.isRequired, height: number.isRequired })).isRequired,
  isWide: bool,
}

export default Card
